import React, { Component } from 'react';
import pick from 'lodash/pick';

import VerifyGuide from './VerifyGuide';

import api from '../../../lib/api';
import endpoints from '../../../lib/endpoints';
import { VERIFICATION_KEYS } from '../../../constants/admin';

export default class VerifyGuideContainer extends Component {
  state = { error: false, verifiedValues: [], isFetching: false };

  setCheckedValues = data => {
    const pickedData = pick(data, VERIFICATION_KEYS);

    const values = Object.keys(pickedData).reduce((a, b) => {
      if (pickedData[b].is_verified) {
        a.push(b);
      }
      return a;
    }, []);

    this.setState({ verifiedValues: values });
  };

  async componentDidMount() {
    const { id } = this.props;
    try {
      this.setState({ error: false });
      this.toggleisFetching();
      const { data } = await api.getWithToken(endpoints.profile.getUserData(id));
      this.setCheckedValues(data);
      this.toggleisFetching();
    } catch (e) {
      this.toggleisFetching();
      this.toggleError();
    }
  }

  toggleisFetching = () =>
    this.setState(prevState => ({ isFetching: !prevState.isFetching }));

  toggleError = () => this.setState(prevState => ({ error: !prevState.error }));

  updateData = data => {
    this.setCheckedValues(data);
  };

  render() {
    const { verifiedValues, isFetching, error } = this.state;
    const { id } = this.props;
    return isFetching ? (
      'Data fetch first I must!'
    ) : error ? (
      'There was some error. Try closing and opening again!'
    ) : (
      <VerifyGuide verifiedValues={verifiedValues} updateData={this.updateData} id={id} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/VerifyGuideContainer.js